function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { useEffect, useRef, useState } from 'react';
import Input from '@/ui/Input';
import MovieSearchCard from '@/ui/MovieSearchCard';
import SearchIcon from './search-icon.svg';
import CloseIcon from './close-icon.svg';
import AsyncState from '@/ui/AsyncState';
import Button from '@/ui/Button';
// Стили
import './SearchMoviesView.scss';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var SearchMoviesView = function SearchMoviesView(_ref) {
    var searchValue = _ref.searchValue, setSearchValue = _ref.setSearchValue, loading = _ref.loading, error = _ref.error, movies = _ref.movies, trimmed = _ref.trimmed, _onLinkClick = _ref.onLinkClick, onReset = _ref.onReset;
    var _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    var inputRef = useRef(null);
    var hasMovies = movies.length > 0;
    var openSearch = function openSearch() {
        return setIsOpen(true);
    };
    var clearSearch = function clearSearch() {
        onReset();
    };
    var closeSearch = function closeSearch() {
        onReset();
        setIsOpen(false);
    };
    var handleClearOrClose = function handleClearOrClose() {
        if (isOpen)
            closeSearch();
        else
            clearSearch();
    };
    useEffect(function () {
        var _inputRef$current;
        if (isOpen)
            (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    }, [isOpen]);
    var showOverlay = Boolean(trimmed) && (isOpen || searchValue.length > 0);
    return /*#__PURE__*/ _jsxs("div", {
        className: "search-films",
        children: [/*#__PURE__*/ _jsx(Button, {
                variant: "ghost",
                type: "button",
                className: "search-films__open-btn",
                onClick: openSearch,
                "aria-label": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u0438\u0441\u043A",
                children: /*#__PURE__*/ _jsx(SearchIcon, {
                    width: 20,
                    height: 20
                })
            }), /*#__PURE__*/ _jsx("div", {
                className: "search-films__inner",
                "data-open": isOpen ? 'true' : 'false',
                children: /*#__PURE__*/ _jsx(Input, {
                    ref: inputRef,
                    id: "search",
                    variant: "search",
                    type: "search",
                    placeholder: "\u041F\u043E\u0438\u0441\u043A",
                    className: "search-films__search",
                    value: searchValue,
                    onChange: function onChange(e) {
                        return setSearchValue(e.target.value);
                    },
                    leftIcon: /*#__PURE__*/ _jsx(SearchIcon, {
                        className: "search-films__icon",
                        width: 20,
                        height: 20
                    }),
                    rightIcon: searchValue || isOpen ? /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        variant: "ghost",
                        className: "search-films__clear-btn",
                        onClick: handleClearOrClose,
                        "aria-label": isOpen ? 'Закрыть поиск' : 'Очистить поиск',
                        children: /*#__PURE__*/ _jsx(CloseIcon, {
                            width: 18,
                            height: 18
                        })
                    }) : null
                })
            }), showOverlay && /*#__PURE__*/ _jsxs("div", {
                className: "search-films__overlay",
                children: [/*#__PURE__*/ _jsx(AsyncState, {
                        loading: loading,
                        error: error,
                        spinnerSize: "sm"
                    }), !loading && !error && /*#__PURE__*/ _jsx(_Fragment, {
                        children: hasMovies ? /*#__PURE__*/ _jsx("ul", {
                            className: "search-films__list",
                            children: movies.map(function (movie) {
                                return /*#__PURE__*/ _jsx("li", {
                                    className: "search-films__item",
                                    children: /*#__PURE__*/ _jsx(MovieSearchCard, {
                                        movie: movie,
                                        onLinkClick: function onLinkClick() {
                                            _onLinkClick === null || _onLinkClick === void 0 || _onLinkClick();
                                            setIsOpen(false);
                                        }
                                    })
                                }, movie.id);
                            })
                        }) : /*#__PURE__*/ _jsx("div", {
                            className: "search-films__not-found",
                            children: "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E"
                        })
                    })]
            })]
    });
};
export default SearchMoviesView;
